<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <OnRatiosEmplois />
      </div>
    </div>
  </div>
</template>

<script>
import OnRatiosEmplois from '@/components/OnRatiosEmplois.vue'

export default {
  name: 'OnRatiosEmploisNm',
  components: {
    OnRatiosEmplois
  }
}

</script>